import { createSlice } from '@reduxjs/toolkit';
import { getUserSettings } from '../../lib';
import { resetApplication } from '../application/slice';
import userSettingsState from './state';
export const userSettingsSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => userSettingsState);
    },
    initialState: userSettingsState,
    name: 'userSettings',
    reducers: {
        errorReceiveModifyUserSettings: state => {
            state.requestingModifyUserSettings = false;
        },
        errorReceiveUserSettings: state => {
            state.requestingUserSettings = false;
        },
        failedReceiveModifyUserSettings: state => {
            state.requestingModifyUserSettings = false;
        },
        failedReceiveUserSettings: state => {
            state.requestingUserSettings = false;
        },
        receiveModifyUserSettings: {
            prepare: (userSettings, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        userSettings
                    }
                };
            },
            reducer: (state, action) => {
                const { consumerAPI, userSettings } = action.payload;
                const modifiedUserSettings = getUserSettings(userSettings, consumerAPI);
                return Object.assign(Object.assign(Object.assign({}, state), modifiedUserSettings), { requestingModifyUserSettings: false });
            }
        },
        receiveUserSettings: {
            prepare: (userSettings, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        userSettings
                    }
                };
            },
            reducer: (state, action) => {
                const { consumerAPI, userSettings } = action.payload;
                const userSettingsObject = getUserSettings(userSettings, consumerAPI);
                return Object.assign(Object.assign(Object.assign({}, state), { requestingUserSettings: false }), userSettingsObject);
            }
        },
        requestModifyUserSettings: {
            prepare: (userSettings, consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI,
                        userSettings
                    }
                };
            },
            reducer: state => {
                state.requestingModifyUserSettings = true;
            }
        },
        requestUserSettings: {
            prepare: (consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI
                    }
                };
            },
            reducer: state => {
                state.requestingUserSettings = true;
            }
        },
        resetUserSettings: () => userSettingsState
    }
});
export const { errorReceiveModifyUserSettings, errorReceiveUserSettings, failedReceiveModifyUserSettings, failedReceiveUserSettings, receiveModifyUserSettings, receiveUserSettings, requestModifyUserSettings, requestUserSettings, resetUserSettings } = userSettingsSlice.actions;
export default userSettingsSlice.reducer;
